import * as z from 'zod'

import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { FAILURE_STEP_NAME } from '@flows/insurance/constants'

const permanent_residence = (params: ContentsNeoStepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getHelperPath('permanent_residence')]: z.boolean(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_contents:steps.contents.permanent_residence.title',
        },
      },
      {
        type: 'choice',
        shouldTrackValues: true,
        name: params.helperFunctions.getHelperPath('permanent_residence'),
        options: [
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.yes',
            },
            value: true,
          },
          {
            label: {
              type: 'translatableText',
              translationKey: 'sharedFlows_common:generic.inputs.no',
            },
            value: false,
          },
        ],
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        contentConfiguration: [
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contents:steps.contents.permanent_residence.info.text1',
            },
          },
          {
            type: 'text',
            text: {
              type: 'translatableText',
              translationKey: 'sharedFlows_contents:steps.contents.permanent_residence.info.text2',
            },
          },
        ],
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getHelperPath('permanent_residence'),
      valueToStepName: {
        true: 'contents_insurance_owned',
        false: FAILURE_STEP_NAME,
      },
    },
  }) as const satisfies AnyStepConfiguration

export default permanent_residence
